<ng-container *ngIf="isSeedRoute; else normalLayout">
  <router-outlet></router-outlet>
</ng-container>
<ng-template #normalLayout>
  <app-header></app-header>

  <div [ngSwitch]="activeModal">
    <app-login-modal *ngSwitchCase="'login'"></app-login-modal>
    <app-register-modal *ngSwitchCase="'register'"></app-register-modal>
    <app-forgot-password-modal *ngSwitchCase="'forgotPassword'"></app-forgot-password-modal>
  </div>
  <app-toast-popup></app-toast-popup>
  <app-loader></app-loader>

  <router-outlet></router-outlet>

  <app-footer></app-footer>
</ng-template>